import moment from "moment";

import { predefinedRanges } from "@8x8/oxygen-date-time-range-selector";

/**
 * Parse a payload object coming from Oxygen's onRangeChange.
 * It can contain either predefinedRange with a given ID
 * (and optionally a value, e.g. for "Last X Months"), or a
 * range object ('dateTime' with attributes startDate, endDate).
 *
 * NOTE 1. The Oxygen object structures are complex and NOT documented,
 * so pay attention to this function to grasp the structure.
 *
 * NOTE 2. The function works with date AND time BUT will trim the
 * dates such that the start date is always 12:00 AM and the end
 * date is 11:59 PM.
 *
 * @param data object from onRangeChange
 * @param fallbackRange object containing startTime and endTime
 * @return {{endDate: Date, startDate: Date}|null}
 */
export const parseOxygenDateRange = (data, fallbackRange = null) => {
  if (!data || Object.keys(data).length === 0) {
    return fallbackRange;
  }

  let rawDateTime;
  if (data?.predefinedRange) {
    const id = data.predefinedRange?.id;
    const predefinedRange = predefinedRanges.find((item) => item.id === id);

    if (predefinedRange?.hasArgument) {
      const value = data.predefinedRange?.value;
      rawDateTime = predefinedRange.dateTimeRange(value);
    } else {
      rawDateTime = predefinedRange.dateTimeRange();
    }
  } else if (data?.dateTime) {
    rawDateTime = data.dateTime;
  } else {
    throw new Error(
      `onRangeChange received unparsable range. ${JSON.stringify(data)}`
    );
  }

  return {
    startDate: moment(rawDateTime?.startDate).startOf("day").toDate(),
    endDate: moment(rawDateTime?.endDate).endOf("day").toDate(),
  };
};
